// Legend title text for the BPM TV surface.
// Port of the legendText branches in BrandPerceptialMapping.Tv.ChartView `renderChart`
// (bpm/tv/chart.coffee L83/L84, L103/L104, L108). Pure.

import { calcPlainText } from '@aytm/app/stats/page/question-views/bpm/components/tv/components/chart/lib/tvPinsFlags'

// version >= 3 → Bayesian averaged scores; otherwise total scores (legacy mds.version gate)
const isBayesian = answer => answer?.mds?.version != null && answer.mds.version >= 3

export const entityLegendText = answer =>
  isBayesian(answer) ? 'Bayesian averaged scores for each entity' : 'Total scores for each entity'

export const attributeLegendText = answer =>
  isBayesian(answer) ? 'Bayesian averaged scores for each attribute' : 'Total scores for each attribute'

// plotBy 'e', specific value: the entity's text as the pins read it, or its placeholder
export const variantLegendText = qv => calcPlainText(qv.text, qv)

// plotBy 'a', specific value: the attribute's text as the flags read it — no placeholder fallback (legacy L104)
export const batchLegendText = batch => calcPlainText(batch.text)
